// const axios = require('axios');

export default {
    name : 'addToCart',

    init()
    {
        this.run();
    },

    run ()
    {
        const elements = document.querySelectorAll('.js_addToCartBtn');

        if (typeof elements === 'object' && elements.length) {
            elements.forEach((el) => {
                el.addEventListener('click', this.addToCart.bind(this));
            });
        }
    },

    addToCart (event)
    {
        let el = null;

        if (typeof event.target.dataset.pid !== 'undefined') {
            el = event.target;
         } else {
            el = event.target.parentNode;
         }

        if (el) {
            const productId = el.dataset.pid ?? null;
            const qty = el.dataset.qty ? parseInt(el.dataset.qty) : 1;

            this.setStatusClass(productId, 'busy');
            this.removeStatusClass(productId, 'added');
            wcRest.addToCart(productId, qty, this.addToCart__callbackSuccess);
        }
    },

    addToCart__callbackSuccess (response)
    {
        if (typeof response.config.data === 'string') {
            const data = JSON.parse(response.config.data);
            document.getElementById('item-'+data.id).classList.add('added');
            document.getElementById('item-'+data.id).classList.remove('busy');
            window['header'].updateCart();
        }
    },

    setStatusClass( productId, className )
    {
        document.getElementById('item-'+productId).classList.add(className);
    },

    removeStatusClass( productId, className )
    {
        document.getElementById('item-'+productId).classList.remove(className);
    },


}